import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "results", "contact_id", "form"];
  static classes = ["hidden"];
  static values = {
    slug: String,
  };

  connect() {
    this.selectedIndex = -1;
    this.results = [];
    this.lastSelectedEmail = "";
  }

  fetchList(event) {
    const trimmed = event.target.value.trim();
    event.target.value = trimmed;
    const query = trimmed;

    if (this.contact_idTarget.value && query !== this.lastSelectedEmail) {
      this.contact_idTarget.value = "";
    }

    if (query.length < 4) {
      this.resultsTarget.classList.add(this.hiddenClass);
      return;
    }

    const search_url = `/${this.slugValue}/contacts/search_contacts?q=${encodeURIComponent(query)}`;

    fetch(search_url)
      .then((response) => response.json())
      .then((data) => {
        this.results = data;
        this.selectedIndex = -1;
        this.renderResults(data);
        if (data.length > 0) {
          this.resultsTarget.classList.remove(this.hiddenClass);
        } else {
          this.resultsTarget.classList.add(this.hiddenClass);
        }
      })
      .catch((error) => console.log(`Error: ${error}`));
  }

  renderResults(data) {
    this.resultsTarget.innerHTML = data
      .map(
        (contact, index) => `
        <div data-action="click->select-contact#select"
             data-id="${contact.id}"
             data-email="${contact.email}"
             data-index="${index}"
             class="autocomplete-result">
          <div data-id="${contact.id}" data-email="${contact.email}">${contact.email}</div>
          <div data-id="${contact.id}">${contact.file_numbers.join(", ")}</div>
        </div>`,
      )
      .join("");
  }

  select(event) {
    event.stopPropagation();

    const email = event.target.dataset.email;

    this.inputTarget.value = email;
    this.lastSelectedEmail = email;

    this.resultsTarget.classList.add(this.hiddenClass);
  }

  assign_contact_id() {
    const enteredEmail = this.inputTarget.value.trim().toLowerCase();

    if (!this.contact_idTarget.value && enteredEmail !== "") {
      const results = this.resultsTarget.querySelectorAll(".autocomplete-result");

      for (const result of results) {
        const resultEmail = result.dataset.email?.trim().toLowerCase();
        if (resultEmail === enteredEmail) {
          this.contact_idTarget.value = result.dataset.id;
          this.lastSelectedEmail = enteredEmail;
          break;
        }
      }
    }
  }

  keydown(event) {
    const isEmailFocused = document.activeElement === this.inputTarget;

    if (
      isEmailFocused &&
      this.results.length &&
      !this.resultsTarget.classList.contains(this.hiddenClass)
    ) {
      const items = this.resultsTarget.querySelectorAll(".autocomplete-result");

      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          this.selectedIndex = (this.selectedIndex + 1) % items.length;
          break;
        case "ArrowUp":
          event.preventDefault();
          this.selectedIndex = (this.selectedIndex - 1 + items.length) % items.length;
          break;
        case "Enter":
          event.preventDefault();
          if (this.selectedIndex >= 0) items[this.selectedIndex].click();
          return;
        case "Escape":
          event.preventDefault();
          this.resultsTarget.classList.add(this.hiddenClass);
          this.selectedIndex = -1;
          return;
        default:
          return;
      }

      items.forEach((item, index) => {
        const isSelected = index === this.selectedIndex;
        item.classList.toggle("selected", isSelected);
        if (isSelected) item.scrollIntoView({ block: "nearest" });
      });
    }
  }

  hideResults() {
    setTimeout(() => {
      if (
        !this.inputTarget.contains(document.activeElement) &&
        !this.resultsTarget.contains(document.activeElement)
      ) {
        this.resultsTarget.classList.add(this.hiddenClass);
        this.selectedIndex = -1;
      }
    }, 100);
  }
}
